import styled from 'styled-components'

export default styled.aside`
  float: right;
`



// WEBPACK FOOTER //
// ./src/components/atoms/Right/index.js